<template lang="pug">

  section.section
    //- PDFだけ2列表示になるように組んでいる
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'org_name')"
          :message="getInputMessage('application.' + prefix + 'org_name')"
          :type="getInputType('application.' + prefix + 'org_name')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'org_name'",
              :data-testid="'check-' + prefix + 'org_name'"
            ) {{labels.org_name}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'org_name')" icon="pencil-alt")
              |
              | {{labels.org_name}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'org_name']",
            :name="'application.' + prefix + 'org_name'",
            :required="showRequired(prefix + 'org_name')",
            :maxlength="maxlen_app[prefix + 'org_name']",
            v-validate="",
            :data-vv-as="labels.org_name",
            data-vv-scope="application",
            :data-testid="'application.' + prefix + 'org_name'",
            expanded
          )
          p(v-else, :data-testid="'application.' + prefix + 'org_name'") {{value[prefix + 'org_name'] || lang_field.empty}}

      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'org_kana')"
          :message="getInputMessage('application.' + prefix + 'org_kana')"
          :type="getInputType('application.' + prefix + 'org_kana')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'org_kana'",
              :data-testid="'check-' + prefix + 'org_kana'"
            ) {{labels.org_kana}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'org_kana')" icon="pencil-alt")
              |
              | {{labels.org_kana}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'org_kana']",
            :name="'application.' + prefix + 'org_kana'",
            :required="showRequired(prefix + 'org_kana')",
            :maxlength="maxlen_app[prefix + 'org_kana']",
            v-validate="",
            :data-vv-as="labels.org_kana",
            data-vv-scope="application",
            :data-testid="'application.' + prefix + 'org_kana'",
            expanded
          )
          p(v-else, :data-testid="'application.' + prefix + 'org_kana'") {{value[prefix + 'org_kana'] || lang_field.empty}}

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'representative_name')"
          :message="getInputMessage('application.' + prefix + 'representative_name')"
          :type="getInputType('application.' + prefix + 'representative_name')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'representative_name'",
              :data-testid="'check-' + prefix + 'representative_name'"
            ) {{labels.representative_name}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'representative_name')" icon="pencil-alt")
              |
              | {{labels.representative_name}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'representative_name']",
            :name="'application.' + prefix + 'representative_name'",
            :required="showRequired(prefix + 'representative_name')",
            :maxlength="maxlen_app[prefix + 'representative_name']"
            v-validate="",
            :data-vv-as="labels.representative_name",
            data-vv-scope="application",
            :data-testid="'application.' + prefix + 'representative_name'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'representative_name'") {{value[prefix + 'representative_name'] || lang_field.empty}}

      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'representative_kana')"
          :message="getInputMessage('application.' + prefix + 'representative_kana')"
          :type="getInputType('application.' + prefix + 'representative_kana')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'representative_kana'",
              :data-testid="'check-' + prefix + 'representative_kana'"
            ) {{labels.representative_kana}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'representative_kana')" icon="pencil-alt")
              |
              | {{labels.representative_kana}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'representative_kana']",
            :name="'application.' + prefix + 'representative_kana'",
            v-validate="",
            :data-vv-as="labels.representative_kana",
            data-vv-scope="application",
            :required="showRequired(prefix + 'representative_kana')",
            :maxlength="maxlen_app[prefix + 'representative_kana']"
            :data-testid="'application.' + prefix + 'representative_kana'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'representative_kana'") {{value[prefix + 'representative_kana'] || lang_field.empty}}

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'dept_name')"
          :message="getInputMessage('application.' + prefix + 'dept_name')"
          :type="getInputType('application.' + prefix + 'dept_name')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'dept_name'",
              :data-testid="'check-' + prefix + 'dept_name'"
            ) {{labels.dept_name}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'dept_name')" icon="pencil-alt")
              |
              | {{labels.dept_name}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'dept_name']",
            :name="'application.' + prefix + 'dept_name'",
            v-validate="",
            :data-vv-as="labels.dept_name",
            data-vv-scope="application",
            :required="showRequired(prefix + 'dept_name')",
            :maxlength="maxlen_app[prefix + 'dept_name']"
            :data-testid="'application.' + prefix + 'dept_name'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'dept_name'") {{value[prefix + 'dept_name'] || lang_field.empty}}

      //-.column.is-half-print.is-full-tablet
        //- PDFで部署の右側を開けるため

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'chrg_name')"
          :message="getInputMessage('application.' + prefix + 'chrg_name')"
          :type="getInputType('application.' + prefix + 'chrg_name')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'chrg_name'",
              :data-testid="'check-' + prefix + 'chrg_name'"
            ) {{labels.chrg_name}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'chrg_name')" icon="pencil-alt")
              |
              | {{labels.chrg_name}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'chrg_name']",
            :name="'application.' + prefix + 'chrg_name'",
            v-validate="",
            :data-vv-as="labels.chrg_name",
            data-vv-scope="application",
            :required="showRequired(prefix + 'chrg_name')",
            :maxlength="maxlen_app[prefix + 'chrg_name']"
            :data-testid="'application.' + prefix + 'chrg_name'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'chrg_name'") {{value[prefix + 'chrg_name'] || lang_field.empty}}

      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'chrg_kana')"
          :message="getInputMessage('application.' + prefix + 'chrg_kana')"
          :type="getInputType('application.' + prefix + 'chrg_kana')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'chrg_kana'",
              :data-testid="'check-' + prefix + 'chrg_kana'"
            ) {{labels.chrg_kana}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'chrg_kana')" icon="pencil-alt")
              |
              | {{labels.chrg_kana}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'chrg_kana']",
            :name="'application.' + prefix + 'chrg_kana'",
            v-validate="",
            :data-vv-as="labels.chrg_kana",
            data-vv-scope="application",
            :required="showRequired(prefix + 'chrg_kana')",
            :maxlength="maxlen_app[prefix + 'chrg_kana']"
            :data-testid="'application.' + prefix + 'chrg_kana'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'chrg_kana'") {{value[prefix + 'chrg_kana'] || lang_field.empty}}

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'tel')"
          :message="getInputMessage('application.' + prefix + 'tel')"
          :type="getInputType('application.' + prefix + 'tel')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'tel'",
              :data-testid="'check-' + prefix + 'tel'"
            ) {{labels.tel}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'tel')" icon="pencil-alt")
              |
              | {{labels.tel}}

          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'tel']",
            :name="'application.' + prefix + 'tel'",
            v-validate="",
            :data-vv-as="labels.tel",
            data-vv-scope="application",
            :required="showRequired(prefix + 'tel')",
            :maxlength="maxlen_app[prefix + 'tel']"
            :data-testid="'application.' + prefix + 'tel'",
            expanded,
            @blur="toHalfWidth(prefix + 'tel')"
          )
          p(v-else, :data-testid="'application.' + prefix + 'tel'") {{value[prefix + 'tel'] || lang_field.empty}}

      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'fax')"
          :message="getInputMessage('application.' + prefix + 'fax')"
          :type="getInputType('application.' + prefix + 'fax')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'fax'",
              :data-testid="'check-' + prefix + 'fax'"
            ) {{labels.fax}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'fax')" icon="pencil-alt")
              |
              | {{labels.fax}}

          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'fax']",
            :name="'application.' + prefix + 'fax'",
            v-validate="",
            :data-vv-as="labels.fax",
            data-vv-scope="application",
            :required="showRequired(prefix + 'fax')",
            :maxlength="maxlen_app[prefix + 'fax']"
            :data-testid="'application.' + prefix + 'fax'",
            expanded,
            @blur="toHalfWidth(prefix + 'fax')"
          )
          p(v-else, :data-testid="'application.' + prefix + 'fax'") {{value[prefix + 'fax'] || lang_field.empty}}

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-two-thirds-tablet.is-half-desktop
        b-field(
          :class="getClassName(prefix + 'zipcode')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'zipcode'",
              :data-testid="'check-' + prefix + 'zipcode'"
            ) {{labels.zipcode}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'zipcode')" icon="pencil-alt")
              |
              | {{labels.zipcode}}

          b-field(
            :message="getInputMessage('application.' + prefix + 'zipcode')"
            :type="getInputType('application.' + prefix + 'zipcode')"
          )
            b-input(
              v-if="$parent.$parent.isEdit",
              v-model="value[prefix + 'zipcode']",
              :name="'application.' + prefix + 'zipcode'",
              v-validate="",
              :data-vv-as="labels.zipcode",
              data-vv-scope="application",
              :required="showRequired(prefix + 'zipcode')",
              :maxlength="maxlen_app[prefix + 'zipcode']"
              :data-testid="'application.' + prefix + 'zipcode'",
              expanded,
              @blur="toHalfWidth(prefix + 'zipcode')"
            )
            p(v-else, :data-testid="'application.' + prefix + 'zipcode'") {{value[prefix + 'zipcode'] || lang_field.empty}}

            .control(v-if="$parent.$parent.isEdit")
              b-button(@click="addressSearch" data-testid="address_search") 住所検索

        p.help.is-danger(v-if="zipMessage") {{zipMessage}}

    //- wkkpdftohtmlがflexboxに完全対応していないため、2列ずつcolumnsで囲っている
    .columns.is-multiline
      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'address')"
          :message="getInputMessage('application.' + prefix + 'address')"
          :type="getInputType('application.' + prefix + 'address')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'address'",
              :data-testid="'check-' + prefix + 'address'"
            ) {{labels.address}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'address')" icon="pencil-alt")
              |
              | {{labels.address}}
          b-input(
            v-if="$parent.$parent.isEdit",
            v-model="value[prefix + 'address']",
            :name="'application.' + prefix + 'address'",
            v-validate="",
            :data-vv-as="labels.address",
            data-vv-scope="application",
            :required="showRequired(prefix + 'address')",
            :maxlength="maxlen_app[prefix + 'address']"
            :data-testid="'application.' + prefix + 'address'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'address'") {{value[prefix + 'address'] || lang_field.empty}}

      .column.is-half-print.is-full-tablet
        b-field(
          :class="getClassName(prefix + 'email')"
          :message="getInputMessage('application.' + prefix + 'email')"
          :type="getInputType('application.' + prefix + 'email')"
        )
          template(slot="label")
            b-checkbox(
              v-if="$parent.$parent.isEdit && showCheckBox",
              v-model="localCheckedFields",
              :native-value="prefix + 'email'",
              :data-testid="'check-' + prefix + 'email'"
            ) {{labels.email}}
            template(v-else)
              b-icon(v-if="showCheckBox && isChecked(prefix + 'email')" icon="pencil-alt")
              |
              | {{labels.email}}
          b-input(
            v-if="$parent.$parent.isEdit",
            type="email",
            v-model="value[prefix + 'email']",
            :name="'application.' + prefix + 'email'",
            :required="showRequired(prefix + 'email')",
            :maxlength="maxlen_app[prefix + 'email']"
            v-validate="",
            :data-vv-as="labels.email",
            data-vv-scope="application",
            :data-testid="'application.' + prefix + 'email'",
            expanded,
          )
          p(v-else, :data-testid="'application.' + prefix + 'email'") {{value[prefix + 'email'] || lang_field.empty}}

</template>

<script>
import Api from '@/repositories/api'
import MixinHandleErrors from '@/mixins/handleErrors'
import { Applications as maxlen_app } from '@/config/maxlengths'
import { fields as lang_field } from '@/lang/ja_JP'
import Util from '@/utils/util'

export default {
  name: 'FormUser',
  mixins: [ MixinHandleErrors ],
  data () {
    return {
      maxlen_app,
      lang_field,
      zipMessage: '',
      requiredFields: [
        'org_name',
        'representative_name',
        'dept_name',
        'chrg_name',
        'tel',
        'zipcode',
        'address',
        'email'
      ],
      localCheckedFields: [],
      labels: {
        org_name: '法人名または組織名',
        org_kana: '法人名または組織名（ふりがな）',
        representative_name: '代表者名',
        representative_kana: '代表者名（ふりがな）',
        dept_name: '部署名',
        chrg_name: 'ご担当者名',
        chrg_kana: 'ご担当者名（ふりがな）',
        tel: '電話番号',
        fax: 'FAX番号',
        zipcode: '郵便番号',
        address: '住所',
        email: 'メールアドレス'
      }
    }
  },
  props: {
    mode: {type: String, required: false, default: 'edit'},
    prefix: {type: String, required: false, default: ''},
    value: {type: Object, required: false, default () { return {} }},
    // お客様情報変更用チェックボックス
    showCheckBox: {type: Boolean, required: false, default: false},
    checkedFields: {type: Array, required: false, default () { return [] }
    }
  },
  methods: {
    showRequired (field) {
      return (!this.showCheckBox || this.isChecked(field)) && Util.isIncludes(this.requiredFields, field)
    },
    // お客様情報変更画面 && (localCheckedFields有 || 無)
    isChecked (field) {
      return Util.isIncludes(this.localCheckedFields, field)
    },
    // // 各種申請書の作成確認画面：空入力時のメッセージ
    // emptyMessage (field) {
    //   if (this.showCheckBox && !this.isChecked()) {
    //     return '(更新しない)'
    //   } else {
    //     return this.lang_field.empty
    //   }
    // },
    addressSearch () {
      this.zipMessage = ''
      if (!this.value[this.prefix + 'zipcode']) return
      let value = this.value
      const ZipcodesApi = Api.get('zipcodes')
      ZipcodesApi
        .getAddress(this.value[this.prefix + 'zipcode'])
        .then(({ data }) => {
          value[this.prefix + 'address'] = data.data
          this.$emit('input', value)
          this.$forceUpdate()
        })
        .catch((e) => {
          value[this.prefix + 'address'] = ''
          this.$emit('input', value)
          this.$forceUpdate()
          this.zipMessage = e.response.data.data.message
        })
    },
    getClassName (field) {
      return {
        required: this.showRequired(field),
        unchecked: this.$parent.$parent.isConf && this.showCheckBox && !this.isChecked(field)
      }
    },
    setCheckedFields () {
      this.localCheckedFields = this.checkedFields
    },
    /**
     * 与えられた項目の値（英数字/記号）を半角に変換する
     * @param {string} field
     */
    toHalfWidth (field) {
      this.value[field] = this.value[field].replace(/[！-～]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248)
      })
      this.$forceUpdate()
    }
  },
  watch: {
    checkedFields () {
      this.setCheckedFields()
    },
    localCheckedFields (localCheckedFields) {
      this.$emit('checked', localCheckedFields)
    }
  },
  created () {
    // prefix解決
    let requiredFields = []
    for (let field of this.requiredFields) {
      requiredFields.push(this.prefix + field)
    }
    this.requiredFields = requiredFields

    if (this.showCheckBox) {
      this.setCheckedFields()
    }
  }
}
</script>

<style scoped>
  .unchecked{
    opacity: 0.3;
  }
  /* #27 BuefyのBUG回避策 */
  .field.has-addons {
    flex-wrap: wrap;
  }
</style>

<style>
  /*!* [global] 隙間が空きすぎるので減らす *!*/
  /*.column .control .help.counter {*/
    /*margin-bottom: -1.5em; !* 自分の高さ（line-height）分減らす *!*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/apps/com/FormUser.vue